import React, { useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { FloatingLabel, FormControl } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useLoading from "hooks/useLoading";
import Loading from "components/Loading/Loading";
import { getModelType } from "common/helpers/reportsHelper";
import { useGetCarDetailsFromTransportationOfficeMutation } from "features/api/constants/constantsApiSlice";
import { toast } from "react-toastify";

// look at scss reset here in stlyes.scss
// react-bootstrap-floating-label reset

type FormControllInsideReactHookFormProps = {
  name: string;
  control: any;
  rules?: Record<string, any>;
  defaultValue?: string;
  error?: string;
  placeholder: string;
  setValue;
  getValues;
};

const FormControlIndiseReactHookForm = ({
  name,
  control,
  rules,
  defaultValue = "",
  error,
  placeholder,
  setValue,
  getValues,
}: FormControllInsideReactHookFormProps) => {
  const { t } = useTranslation();
  const initalLicenseNumber = useRef(getValues("licenseNumber"));

  const [loading, startLoading, stopLoading] = useLoading();
  const [carDetailsBylicensePlateNumber] =
    useGetCarDetailsFromTransportationOfficeMutation();

  const [licenseNumberAnnouncment, setLicenseNumberAnnouncment] =
    useState(null);

  const resetField = () => {
    setTimeout(() => setLicenseNumberAnnouncment(null), 2000);
    setValue("modelType", null);
    setValue("carColor", null);
    setValue("manufacturerName", null);
    setValue("carModel", null);
  };

  const errorHandeling = () => {
    stopLoading();
    setLicenseNumberAnnouncment(t("notFoundLicsenceNumber"));
    toast.error(t("notFoundLicsenceNumber"), {
      autoClose: 2000,
    });
    resetField();
  };

  const handleBlur = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.id === "licenseNumber" && e.target.value !== "") {
      const lastLicenseNumberInput = e.target.value;
      setValue("licenseNumber", lastLicenseNumberInput);
      startLoading();

      try {
        const response = await carDetailsBylicensePlateNumber({
          licensePlateNumber: e.target.value,
        }).unwrap();
        stopLoading();

        const dataFromApi = response;

        setValue("carModel", getModelType(dataFromApi.carModel)); // סוג רכב
        setValue("carColor", dataFromApi.carColor ?? t("noData"));
        setValue("modelType", dataFromApi.modelType ?? t("noData")); // דגם
        setValue(
          "manufacturerName",
          dataFromApi.manufacturerName ?? t("noData")
        ); // שם יצרן
        if (lastLicenseNumberInput === initalLicenseNumber.current) {
          setLicenseNumberAnnouncment(null);
        } else {
          setLicenseNumberAnnouncment(
            t("attentionAnnouncmentLicsenceNumberNotAsUser")
          );
        }
      } catch (err) {
        console.error("Error:", err);
        errorHandeling();
      }
    }
  };

  const generateLicenseNumberAnnouncment = () => {
    return <span>{licenseNumberAnnouncment}</span>;
  };
  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => (
          <FloatingLabel controlId={name} label={placeholder}>
            <FormControl
              placeholder={placeholder}
              value={value ?? ""}
              onChange={(e) => {
                onChange(e);
              }}
              onBlur={(e) => {
                handleBlur(e as React.ChangeEvent<HTMLInputElement>);
              }}
              // waiting for customer decision:
              // onKeyDown={handleKeyDown}
              disabled={name !== "licenseNumber"}
              style={{ fontSize: 16 }}
            />
            {loading && <Loading text={t("checkingLicensingMinistryData")} />}
            {error && <span className="requiredField">*{error}</span>}
          </FloatingLabel>
        )}
      />
      {name === "licenseNumber" && generateLicenseNumberAnnouncment()}
    </>
  );
};

export default FormControlIndiseReactHookForm;
